import axios from 'axios'
import qs from 'qs'

// axios.defaults.baseURL = 'http://bio.devp/BiologicalStemCell';
// axios.defaults.baseURL = '/BiologicalStemCell';
axios.defaults.baseURL = '/mm-api/BiologicalStemCell';
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data.data);
    }).catch(err => {
      reject(err.data)
    })
  })
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err =>{
        reject(err.data)
      })
  });
}



// WEBPACK FOOTER //
// ./src/request/http.js